(() => {
  if (window.__wnJourneysCartReady) return;
  window.__wnJourneysCartReady = true;

  const getRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const injectDesktopCartStyles = () => {
    let style = document.getElementById('wn-cart-drawer-desktop-styles');
    if (!style) {
      style = document.createElement('style');
      style.id = 'wn-cart-drawer-desktop-styles';
      document.head.appendChild(style);
    }

    style.textContent = `
      @media (min-width: 768px) {
        #MinimogCartDrawer .m-cart-drawer__inner {
          height: 100vh !important;
          height: 100dvh !important;
          max-height: 100vh !important;
          max-height: 100dvh !important;
          overflow: hidden !important;
        }
  
        #MinimogCartDrawer #MinimogCartDrawerHeader {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) !important;
          grid-template-rows: auto auto minmax(0, 1fr) auto !important;
          height: 100% !important;
          min-height: 0 !important;
          max-height: 100% !important;
          overflow: hidden !important;
        }
  
        #MinimogCartDrawer .wncd-topbar {
          grid-row: 1 !important;
          grid-column: 1 !important;
          min-width: 0 !important;
          flex: none !important;
        }
  
        #MinimogCartDrawer .m-cart-drawer__header {
          grid-row: 2 !important;
          grid-column: 1 !important;
          min-width: 0 !important;
          flex: none !important;
          position: relative !important;
          z-index: 3 !important;
        }
  
        #MinimogCartDrawer .m-cart-drawer__body {
          grid-row: 3 !important;
          grid-column: 1 !important;
          min-width: 0 !important;
          min-height: 0 !important;
          height: 100% !important;
          max-height: 100% !important;
          display: block !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          overscroll-behavior-y: contain !important;
          -webkit-overflow-scrolling: touch !important;
          touch-action: pan-y !important;
          scrollbar-width: thin !important;
          scrollbar-gutter: stable !important;
          padding-bottom: 34px !important;
        }
  
        #MinimogCartDrawer .m-cart-drawer__body::-webkit-scrollbar {
          width: 6px !important;
        }
  
        #MinimogCartDrawer .m-cart-drawer__body::-webkit-scrollbar-thumb {
          background: rgba(16, 26, 43, .28) !important;
          border-radius: 99px !important;
        }
  
        #MinimogCartDrawer .m-cart-drawer__body::-webkit-scrollbar-track {
          background: rgba(16, 26, 43, .06) !important;
        }
  
        #MinimogCartDrawer .m-cart-drawer__footer {
          grid-row: 4 !important;
          grid-column: 1 !important;
          min-width: 0 !important;
          flex: none !important;
          flex-shrink: 0 !important;
          position: relative !important;
          inset: auto !important;
          z-index: 12 !important;
          margin: 0 !important;
        }
  
        #MinimogCartDrawer .m-cart-drawer__footer--wrapper {
          position: relative !important;
          inset: auto !important;
          margin: 0 !important;
        }
  
        #MinimogCartDrawer .wncd-upsell {
          width: 100% !important;
          max-width: 100% !important;
          overflow: hidden !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-head {
          margin-bottom: 12px !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-track {
          display: flex !important;
          flex-wrap: nowrap !important;
          align-items: stretch !important;
          gap: 10px !important;
          width: 100% !important;
          max-width: 100% !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          scroll-snap-type: x proximity !important;
          scroll-behavior: smooth !important;
          overscroll-behavior-x: contain !important;
          -webkit-overflow-scrolling: touch !important;
          touch-action: pan-x !important;
          padding: 2px 2px 10px !important;
          scrollbar-width: thin !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-track::-webkit-scrollbar {
          display: block !important;
          height: 5px !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-track::-webkit-scrollbar-thumb {
          background: rgba(16, 26, 43, .28) !important;
          border-radius: 99px !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-track::-webkit-scrollbar-track {
          background: rgba(16, 26, 43, .07) !important;
          border-radius: 99px !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-card {
          flex: 0 0 178px !important;
          width: 178px !important;
          min-width: 178px !important;
          height: auto !important;
          min-height: 276px !important;
          display: flex !important;
          flex-direction: column !important;
          scroll-snap-align: start !important;
          overflow: hidden !important;
          transition: opacity .2s ease, transform .2s ease, width .2s ease, min-width .2s ease, margin .2s ease, padding .2s ease;
        }
  
        #MinimogCartDrawer .wncd-upsell-card.wncd-removing {
          opacity: 0 !important;
          transform: scale(.94) !important;
          pointer-events: none !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-image {
          flex: 0 0 118px !important;
          width: 100% !important;
          min-height: 118px !important;
          max-height: 118px !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-image img {
          width: 100% !important;
          height: 100% !important;
          object-fit: contain !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-title {
          display: -webkit-box !important;
          min-height: 36px !important;
          max-height: 36px !important;
          -webkit-line-clamp: 2 !important;
          -webkit-box-orient: vertical !important;
          overflow: hidden !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-price {
          flex: 0 0 auto !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-card form {
          margin-top: auto !important;
          width: 100% !important;
        }
  
        #MinimogCartDrawer .wncd-upsell-card .wn-journeys__cart-btn {
          width: 100% !important;
        }
      }
    `;
  };

  const normaliseUpsellTrack = (track) => {
    if (!track) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    if (track.scrollLeft > maxScroll) track.scrollLeft = maxScroll;

    const cards = Array.from(track.querySelectorAll('.wncd-upsell-card'));
    const upsell = track.closest('.wncd-upsell');
    if (upsell && cards.length === 0) upsell.remove();
  };

  const pruneUpsellCards = (root = document) => {
    const cards = root.querySelectorAll
      ? root.querySelectorAll('#MinimogCartDrawer .wncd-upsell-card')
      : [];

    cards.forEach((card) => {
      const button = card.querySelector('.wn-journeys__cart-btn');
      if (!button) return;

      const label = (button.textContent || '').trim().toLowerCase();
      if (label === 'in cart') {
        const track = card.closest('.wncd-upsell-track');
        card.remove();
        normaliseUpsellTrack(track);
      }
    });

    if (root.querySelectorAll) {
      root.querySelectorAll('#MinimogCartDrawer .wncd-upsell-track').forEach(normaliseUpsellTrack);
    }
  };

  const observeDrawer = () => {
    const drawer = document.querySelector('#MinimogCartDrawer');
    if (!drawer) return;

    pruneUpsellCards(drawer);

    if (drawer.dataset.wnUpsellObserver === 'true') return;
    drawer.dataset.wnUpsellObserver = 'true';

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(() => pruneUpsellCards(drawer));
    });

    observer.observe(drawer, { childList: true, subtree: true });
  };

  injectDesktopCartStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer, { once: true });
  } else {
    observeDrawer();
  }

  document.addEventListener('cart:refresh', () => {
    window.setTimeout(observeDrawer, 120);
    window.setTimeout(() => pruneUpsellCards(document), 450);
    window.setTimeout(() => pruneUpsellCards(document), 900);
  });

  const openNativeCartDrawer = () => {
    const drawer = document.querySelector('#MinimogCartDrawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    const cartIcon = document.querySelector('.m-cart-icon-bubble');
    if (cartIcon) {
      cartIcon.click();
      return true;
    }

    return false;
  };

  // Keep the existing desktop wheel-to-horizontal behavior. Mobile uses native touch scrolling.
  document.addEventListener('wheel', (event) => {
    const track = event.target && event.target.closest
      ? event.target.closest('#MinimogCartDrawer .wncd-upsell-track')
      : null;

    if (window.innerWidth <= 767 || !track || track.scrollWidth <= track.clientWidth + 2) return;

    const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
    if (!delta) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft >= maxScroll - 1;

    if ((delta < 0 && atStart) || (delta > 0 && atEnd)) return;

    event.preventDefault();
    track.scrollLeft = Math.max(0, Math.min(maxScroll, track.scrollLeft + delta));
  }, { passive: false, capture: true });

  // Desktop drag-to-scroll for the recommended product cards.
  let dragState = null;

  document.addEventListener('pointerdown', (event) => {
    const track = event.target && event.target.closest
      ? event.target.closest('#MinimogCartDrawer .wncd-upsell-track')
      : null;

    if (!track || event.pointerType === 'touch' || event.target.closest('a, button, input, form')) return;

    dragState = {
      track,
      pointerId: event.pointerId,
      startX: event.clientX,
      startScrollLeft: track.scrollLeft
    };

    track.setPointerCapture?.(event.pointerId);
    track.style.cursor = 'grabbing';
  }, true);

  document.addEventListener('pointermove', (event) => {
    if (!dragState || dragState.pointerId !== event.pointerId) return;
    const distance = event.clientX - dragState.startX;
    dragState.track.scrollLeft = dragState.startScrollLeft - distance;
  }, true);

  const finishDrag = (event) => {
    if (!dragState || (event && dragState.pointerId !== event.pointerId)) return;
    dragState.track.style.cursor = '';
    try { dragState.track.releasePointerCapture?.(dragState.pointerId); } catch (_) {}
    dragState = null;
  };

  document.addEventListener('pointerup', finishDrag, true);
  document.addEventListener('pointercancel', finishDrag, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target && event.target.closest
      ? event.target.closest('.wn-journeys__cart-form')
      : null;

    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    if (form.dataset.wnAdding === 'true') return;

    const button = form.querySelector('.wn-journeys__cart-btn');
    const variantInput = form.querySelector('[name="id"]');
    const variantId = variantInput ? Number(variantInput.value) : 0;

    if (!variantId || !button || button.disabled) return;

    form.dataset.wnAdding = 'true';
    const originalText = button.textContent.trim();
    const upsellCard = form.closest('.wncd-upsell-card');
    const upsellTrack = upsellCard ? upsellCard.closest('.wncd-upsell-track') : null;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding...';

    try {
      const root = getRoot();
      const addUrl =
        (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url) ||
        `${root}cart/add.js`;

      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });

      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        throw new Error(result.description || result.message || 'Unable to add this product to cart.');
      }

      button.textContent = 'Added';

      if (upsellCard) {
        upsellCard.classList.add('wncd-removing');
        window.setTimeout(() => {
          upsellCard.remove();
          normaliseUpsellTrack(upsellTrack);
        }, 180);
      }

      const journeysSection = form.closest('.wn-journeys');
      const reelModal = journeysSection && journeysSection.querySelector('[data-modal]');
      if (reelModal && !reelModal.hidden) {
        const closeButton = reelModal.querySelector('[data-close-modal]');
        if (closeButton) {
          closeButton.click();
        } else {
          reelModal.hidden = true;
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        }
      }

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: { open: true }
        })
      );

      window.setTimeout(() => {
        injectDesktopCartStyles();
        observeDrawer();
        pruneUpsellCards(document);
        openNativeCartDrawer();
      }, 500);
    } catch (error) {
      console.error('[Wander Nation] Add to cart failed:', error);
      button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => {
        form.dataset.wnAdding = 'false';
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (button.isConnected) button.textContent = originalText;
      }, 1400);
    }
  }, true);
})();
